// @flow

import * as React from "react"
import Icon from "./icon"
import ClassNames from "classnames"
import {isFunction, keys, countBy, debounce} from "lodash"
import {connect} from "react-redux"
import {
  bulkToggleSearchItems,
  addSearchItemFound,
  updateSearchItemFound,
} from "../actions/search-items"
import {getNextFoundState} from "../reducers/search-items"
import type {
  SearchListItem,
  BabyListItemFoundStateType,
  Dispatch,
} from "../types"

type Props = {
  isSingle: boolean,
  isMultiComplete: boolean,
  isStandalone: boolean,
  babyListItemFoundId: ?number,
  productId: number,
  babyListItemId: number,
  searchListItem: ?SearchListItem,
  searchListItemId: number,
  onClick: () => void,
  state: BabyListItemFoundStateType,
  dispatch: Dispatch,
}

const CLICK_DEBOUNCE_TIMEOUT = 200

class SearchItemStateToggle extends React.Component<Props> {
  static defaultProps = {
    isSingle: true,
    isMultiComplete: false,
    isStandalone: true,
  }

  handleClick: () => void
  debouncedHandleClick: () => void

  constructor(props: Props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
    this.debouncedHandleClick = debounce(
      this.handleClick,
      CLICK_DEBOUNCE_TIMEOUT,
      {leading: true}
    )
  }

  handleClick() {
    const {
      isSingle,
      babyListItemFoundId,
      babyListItemId,
      productId,
      searchListItem,
      searchListItemId,
      dispatch,
      isStandalone,
      state,
      onClick,
    } = this.props
    if (onClick && isFunction(onClick)) {
      onClick()
    }
    if (isSingle) {
      const nextFoundState = getNextFoundState(state)
      if (!babyListItemFoundId) {
        dispatch(
          addSearchItemFound(
            productId,
            babyListItemId,
            searchListItemId,
            nextFoundState
          )
        )
      } else {
        dispatch(
          updateSearchItemFound(
            productId,
            babyListItemId,
            babyListItemFoundId,
            searchListItemId,
            nextFoundState,
            null
          )
        )
      }
    } else {
      // standalone does nothing
      if (!isStandalone) {
        return
      }
      // open
      // the searchItem should always be set when Multi
      if (searchListItem) {
        // we do not toggle on the dashboard search view
        // to check if we are there, there should only by one
        // baby list accross all checked items
        const byState = countBy(searchListItem.items, "babyListId")
        const isGroupView =
          keys(byState).filter((babyListId, count) => count > 1).length > 1
        if (!isGroupView) {
          dispatch(bulkToggleSearchItems(searchListItem))
        }
      }
    }
  }

  getIconName(state: BabyListItemFoundStateType) {
    const {isSingle, searchListItem} = this.props
    if (!isSingle && searchListItem) {
      const byState = keys(countBy(searchListItem.items, "state"))
      const isMultiFoundState = byState.length > 1
      if (isMultiFoundState) {
        return "icon-checkbox-checked-multi-cross"
      } else {
        if (byState[0] == "null" || byState[0] == "missing") {
          return "icon-checkbox-unchecked-multi"
        } else {
          return "icon-checkbox-checked-multi"
        }
      }
    }
    switch (state) {
      case "todo":
      case "ok":
      case "ordered":
        return "icon-checkbox-checked"
      case "missing":
      default:
        return "icon-checkbox-unchecked"
    }
  }

  getFoundState() {
    // for single items, easy
    // for multi, if all the same, return it, otherwise, no found state
    const {isSingle, searchListItem, state} = this.props
    if (isSingle) {
      return state
    } else {
      const byState = countBy(searchListItem.items, "state")
      // console.log(searchListItem)
      // console.log(byState)
      const isMultiFoundState = keys(byState).length > 1
      return isMultiFoundState ? "" : keys(byState)[0]
    }
  }

  render() {
    const {isSingle} = this.props
    const foundState = this.getFoundState()
    const className = ClassNames(
      "search-item-state-toggle",
      `is-${foundState}`,
      {
        "is-single": isSingle,
        "is-multi": !isSingle,
      }
    )
    return (
      <div className={className} onClick={this.debouncedHandleClick}>
        <Icon name={this.getIconName(foundState)} />
      </div>
    )
  }
}

export default connect()(SearchItemStateToggle)
